/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SurfaceOnboardingStep
 */
export interface SurfaceOnboardingStep {
    /**
     * 
     * @type {string}
     * @memberof SurfaceOnboardingStep
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof SurfaceOnboardingStep
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof SurfaceOnboardingStep
     */
    imageUrl?: string;
}

/**
 * Check if a given object implements the SurfaceOnboardingStep interface.
 */
export function instanceOfSurfaceOnboardingStep(value: object): value is SurfaceOnboardingStep {
    return true;
}

export function SurfaceOnboardingStepFromJSON(json: any): SurfaceOnboardingStep {
    return SurfaceOnboardingStepFromJSONTyped(json, false);
}

export function SurfaceOnboardingStepFromJSONTyped(json: any, ignoreDiscriminator: boolean): SurfaceOnboardingStep {
    if (json == null) {
        return json;
    }
    return {
        
        'title': json['title'] == null ? undefined : json['title'],
        'description': json['description'] == null ? undefined : json['description'],
        'imageUrl': json['imageUrl'] == null ? undefined : json['imageUrl'],
    };
}

export function SurfaceOnboardingStepToJSON(json: any): SurfaceOnboardingStep {
    return SurfaceOnboardingStepToJSONTyped(json, false);
}

export function SurfaceOnboardingStepToJSONTyped(value?: SurfaceOnboardingStep | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'title': value['title'],
        'description': value['description'],
        'imageUrl': value['imageUrl'],
    };
}

